import './CustomerPicker/styles.scss';
import './ServePlacePicker/styles.scss';
import './EmployeePicker/styles.scss';
import './ToppingEditor/styles.scss';
import CustomerPicker from './CustomerPicker';
import ServePlacePicker from './ServePlacePicker';
import EmployeePicker from './EmployeePicker';
import ToppingEditor from './ToppingEditor';

export const PickerRegistry = {
    CustomerPicker,
    ServePlacePicker,
    EmployeePicker,
    ToppingEditor
};

export { CustomerPicker, ServePlacePicker, EmployeePicker, ToppingEditor };
